import SpinWheel from ".";
import ManageSpinWheel from "../../../../components/sections/admin/SpinWheel/ManageSpinWheel";

export const wheelRoutes = () => [
  {
    path: "/admin/spin-wheel",
    title: "Spin Wheel Management",
    layout: "admin",
    routeType: "admin",
    component: SpinWheel,
  },
  {
    path: "/admin/manage-spin-wheel",
    component: ManageSpinWheel,
    layout: "admin",
    routeType: "admin",
    title: "Manage Spin Wheel",
  },
  {
    path: `/admin/manage-spin-wheel/:id`,
    component: ManageSpinWheel,
    layout: "admin",
    routeType: "admin",
    title: "Manage Spin Wheel",
  },
];
